import {
  DarkGreenFilledLeafLarge,
  EvrgreenCommitment,
  RecycleLogo,
  ReduceLogo,
  ReuseLogo,
  TreeDeciduousRegularLarge,
  Worker,
} from "./WhyEvrbed.images";
import { StyledDivWithRadius } from "./WhyEvrbed.styles";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import ContainedButton from "../../components/Buttons/ContainedButton";
import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import {SHOPIFY_URL} from "../../utils/shopify.utils";

const SlideContainer = styled(StyledDivWithRadius)`
  flex-direction: row;
  min-width: 1402px;
  margin-right: 80px;
`;

const SustainabilityMatters = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  let navigate = useNavigate();
  return (
    <SlideContainer backgroundColor={"#e3efe3"}>
      <FirstHalfContent>
        <TreeDeciduousRegularLarge />
        <Content theme={theme}>
          <Title>Sustainability Matters</Title>
          <Subtitle>More Than Just Comfort</Subtitle>
          <Paragraph>
            {
              "We recycle every evrbed and component produced. We'll even recycle your old mattress when you purchase an evrbed. Plus, 1% of every purchase goes to our innovation fund."
            }
          </Paragraph>
          <GreenButton
            size={{ height: "53px" }}
            t={t}
            onClick={() => window.top.location.href = SHOPIFY_URL + "pages/mattress-builder"}
            text={"BUILD MY BED"}
          />
        </Content>
      </FirstHalfContent>
      <SecondHalfContent>
        <EvrgreenCommitment />
        <CycleContainer>
          <CycleItem width={136}>
            <LogoContainer>
              <ReduceLogo />
            </LogoContainer>
            <CycleContent theme={theme}>
              <CycleTitle>Reduce</CycleTitle>
              <CycleParagraph>
                {
                  "Less mattress turnover equals less waste that ends up in landfills."
                }
              </CycleParagraph>
            </CycleContent>
          </CycleItem>
          <CycleItem width={152}>
            <LogoContainer>
              <ReuseLogo />
            </LogoContainer>
            <CycleContent theme={theme}>
              <CycleTitle>Reuse</CycleTitle>
              <CycleParagraph>
                {
                  "Replaceable components mean the evrbed lasts 3 times longer than a traditional mattress!"
                }
              </CycleParagraph>
            </CycleContent>
          </CycleItem>
          <CycleItem width={163}>
            <LogoContainer>
              <RecycleLogo />
            </LogoContainer>
            <CycleContent theme={theme}>
              <CycleTitle>Recycle</CycleTitle>
              <CycleParagraph>
                {
                  "We have committed to recycling every evrbed produced. We will even take away and recycle your old mattress, hassle free."
                }
              </CycleParagraph>
            </CycleContent>
          </CycleItem>
        </CycleContainer>
        <ImageContainer>
          <PositionedWorker />
          <PositionedDarkGreenFilledLeafLarge />
          <YouShouldTitle>{"You Shouldn't Have to Choose"}</YouShouldTitle>
          <YouShouldParagraph>
            {"With evrbed, you get sustainability and lifetime value."}
          </YouShouldParagraph>
        </ImageContainer>
        <ButtonContainer>
          <GreenButton
            onClick={() => window.top.location.href = SHOPIFY_URL + "pages/our-commitment"}
            text={"VIEW COMMITMENT"}
            size={{ height: "53px" }}
            t={t}
          />
        </ButtonContainer>
      </SecondHalfContent>
    </SlideContainer>
  );
};

const PositionedWorker = styled(Worker)`
  position: absolute;
  margin-top: 100px;
  margin-left: -458px;
`;

const PositionedDarkGreenFilledLeafLarge = styled(DarkGreenFilledLeafLarge)`
  position: absolute;
  margin-top: 70px;
  margin-left: 40px;
`;

const ButtonContainer = styled.div`
  position: relative;
  margin-top: 280px;
  margin-left: 440px;
`;

const FirstHalfContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const SecondHalfContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const Content = styled.div`
  color: ${props => props.theme.COLORS.GREEN.lightGreen};
  font-family: "noto-sans", sans-serif;
  margin-left: 57px;
`;

const Title = styled.h1`
  font-size: 50px;
  line-height: 66px;
  padding-top: 40px;
  width: 622px;
`;

const Subtitle = styled.h2`
  font-size: 38px;
  line-height: 66px;
  padding-top: 10px;
  width: 508px;
`;

const Paragraph = styled.p`
  font-size: 24px;
  line-height: 40px;
  padding-top: 20px;
  width: 420px;
`;

const GreenButton = ({ onClick, t, text, margin, size }) => (
  <ContainedButton
    onClick={onClick}
    styles={{
      ...size,
      margin,
    }}
  >
    {t(text)}
  </ContainedButton>
);

const CycleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: start;
  width: 100%;
  margin-top: 59px;
  padding: 0 0 0 30px;
`;

const CycleItem = styled.div.attrs(props => ({
  style: {
    width: `${props.width}px`,
  },
}))`
  display: flex;
  flex-direction: column;
`;

const CycleContent = styled.div`
  color: ${props => props.theme.COLORS.GREEN.lightGreen};
  font-family: "noto-sans", sans-serif;
  padding-top: 20px;
`;

const CycleTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin: 0;
`;

const CycleParagraph = styled.p`
  padding-top: 7px;
  font-size: 14px;
  line-height: 20px;
`;

const LogoContainer = styled.div`
  height: 55px;
  width: 88px;
`;

const ImageContainer = styled.div`
  position: relative;
`;

const YouShouldTitle = styled.h2`
  position: absolute;
  font-size: 22px;
  line-height: 30px;
  font-weight: bold;
  color: white;
  margin-top: 92px;
  margin-left: 80px;
  width: 189px;
`;

const YouShouldParagraph = styled.p`
  position: absolute;
  font-size: 16px;
  line-height: 25px;
  color: white;
  margin-top: 170px;
  margin-left: 80px;
  width: 170px;
  text-align: center;
`;

export default SustainabilityMatters;
